/* src/pages/LandingPage.js */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle, signOut } from '../apiClient';
import { logVisit } from '../analytics';      // <--- FIXED: Up one level

// --- STYLES ---
const styles = {
  desktopContainer: {
    width: '100%',
    maxWidth: '1200px',
    boxShadow: '0 0 25px rgba(0, 0, 0, 0.15)',
    margin: '0 auto',
    borderRadius: '10px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgba(253, 250, 245, 0.9)',
   
  },
  header: {
    backgroundColor: '#e8e4d9',
    padding: '15px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #d3cdc1',
  },
			  
					
  logoGroup: { display: 'flex', alignItems: 'center' },
  logoImg: { maxWidth: '50px', height: 'auto', marginRight: '15px' },
			
					 
				   
						
	
		   
  logoH1: { fontFamily: "'Playfair Display', serif", fontSize: '1.8em', color: '#5a4b41', margin: 0, fontWeight: 700 },
  tagline: { fontFamily: "'Lato', sans-serif", fontSize: '1em', color: '#5a4b41', margin: '0 0 0 15px', fontWeight: 300 },
					 
			  
					
	
			
									 
					
					 
						 
					
	
  loginLink: {
    fontSize: '1em', color: '#777', textDecoration: 'none', display: 'flex', alignItems: 'center',
    padding: '8px 15px', border: '1px solid #d3cdc1', borderRadius: '20px', cursor: 'pointer',
						   
					
						 
						
								
						 
					  
					   
    background: '#fff', fontFamily: 'inherit',
  
 
  
 
  
   
  
   
  },
  loggedInUser: { fontSize: '1em', color: '#5a4b41', display: 'flex', alignItems: 'center', gap: '15px' },
   
  
  
					
					 
					
						 
				
  
   
 
	
  logoutButton: {
    fontSize: '0.8em', color: '#777', border: '1px solid #d3cdc1', borderRadius: '20px',
 
  
				  
								
						 
						
					  
 
   
    padding: '5px 10px', cursor: 'pointer', fontFamily: 'inherit',
  },
  mainContent: { padding: '40px 20px', backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px' },
  mainNav: { display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px', width: '100%', maxWidth: '900px' },
								   
					
							
						 
				
	
			
					
					 
							 
				
				  
					  
	
  navButton: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15px 25px',
    backgroundColor: '#b08d6d', color: '#fff', textDecoration: 'none', borderRadius: '30px',
							 
						 
							   
				  
						   
						 
					  
					
    fontSize: '1.1em', fontWeight: 500, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', textAlign: 'center',
						
					  
					  
					  
    minWidth: '180px', maxWidth: '280px', cursor: 'pointer', transition: 'background-color 0.3s ease',
    fontFamily: 'inherit', border: 'none',
				   
  },
				  
  navButtonIcon: { marginRight: '10px', fontSize: '1.3em' },
  featureBlocks: { display: 'flex', gap: '30px', width: '100%', justifyContent: 'center', flexWrap: 'wrap' },
	
				  
					
				
				  
							 
					 
	
  featureBlock: {
    backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden',
						
					   
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)', flex: '1 1 45%', maxWidth: '500px', minWidth: '300px',
					
					  
					  
  },
  featureImg: { width: '100%', height: '220px', objectFit: 'cover', display: 'block' },
				  
					
					   
					 
  
   
   
	
  featureContent: { padding: '25px', gap: '10px' },
					
				
	
			  
  featureH2: { fontFamily: "'Playfair Display', serif", fontSize: '1.6em', color: '#5a4b41', margin: 0 },
  featureP: { fontSize: '1em', lineHeight: 1.6, color: '#333', margin: '10px 0 0 0' },
					 
			  
 
   
	
			 
					
					
				  
						 
	
  seoSections: {
    backgroundColor: '#d3cdc1', color: '#333', padding: '50px 40px',
				  
						 
					
    display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px',
				
  },
				 
  seoSectionH3: { fontFamily: "'Playfair Display', serif", fontSize: '1.4em', color: '#000', marginTop: 0 },
  seoLinkList: { listStyle: 'none', padding: 0, marginTop: '15px' },
				  
				 
	
											 
					  
			   
					  
	
  seoLinkListItem: { marginBottom: '8px' },
  seoLink: { color: '#5a4b41', textDecoration: 'none', fontWeight: '600', display: 'flex', alignItems: 'center' },
	
			
					 
						   
					  
					
						 
	
				
  seoLinkIcon: { marginRight: '8px', color: '#b08d6d' },
					 
	
																	   
			   
															   
  seoSection: { minHeight: '200px' },
  footer: { backgroundColor: '#5a4b41', color: '#fff', textAlign: 'center', padding: '20px', fontSize: '0.9em' }
		   
							   
				  
						
					
					  
   
};
					 

   
   
  
  
   

  
  
   
  
 

   
function LandingPage({ session, profile }) {
  const navigate = useNavigate();
  
   
   
 
   

  // Analytics Hook
  useEffect(() => {
    logVisit('LandingPage');
  }, []);
   
   
  
  

 
   
  

  
   
 

 
  const handleGoogleLogin = async () => {
 
    const redirectUrl = window.location.origin + window.location.pathname;
  
									 
 
																  
 
  
 

    await signInWithGoogle();
  };

  
  const handleSignOut = async () => {
 
  
  
    await signOut();
  };
  

 
  const handleFiveDayClick = () => {
    if (session) {
      // Logged in? Go to Dashboard
      navigate('/dashboard');
    } else {
      // Not logged in? Go to Info Page
      navigate('/about-5dd');
    }
  };

  
  const renderHeaderLogin = () => {
    if (session && profile) {
      return (
        <div style={styles.loggedInUser}>
          <span>Hi, {profile.full_name || 'User'}</span>
          <button onClick={handleSignOut} style={styles.logoutButton}>
            Logout
          </button>
        </div>
      );
    } else {
      return (
        <button onClick={handleGoogleLogin} style={styles.loginLink}>
          <i className="fas fa-lock" style={{marginRight: '8px'}}></i> Login
        </button>
      );
    }
  };

 
  return (
    <div style={{width: '100%'}}>
      <div style={styles.desktopContainer}>
        <header style={styles.header}>
          <div style={styles.logoGroup}>
  
  
  
            <img src="/assets/hhy_logo.png" alt="Hash House Yoga Logo" style={styles.logoImg} />
            <div>
              <h1 style={styles.logoH1}>Hash House Yoga</h1>
              <p style={styles.tagline}>A simple practice for real life.</p>
            </div>
          </div>
          {renderHeaderLogin()}
        </header>

        <main style={styles.mainContent}>
         <nav style={styles.mainNav}>
  {/* BUTTON 1: Five Breath Experience */}
  <button onClick={() => navigate('/five-breaths')} style={styles.navButton}>
    <i className="fas fa-lungs" style={styles.navButtonIcon}></i> 5 Breath Experience
  </button>

  {/* BUTTON 2: The Hash House Five */}
  <a href="/hh5/" style={styles.navButton}>
    <i className="fas fa-hand-holding-heart" style={styles.navButtonIcon}></i> The Hash House Five
  </a>

  {/* NEW BUTTON: The Journal */}
   <a href="/journal/" style={styles.navButton}>
    <i className="fas fa-hand-holding-heart" style={styles.navButtonIcon}></i> The Journal
  </a>

  {/* BUTTON 3: 5DD (Highlighted) */}
  <button onClick={handleFiveDayClick} style={{...styles.navButton, ...{backgroundColor: '#b08d6d'}}}>
    <i className="fas fa-calendar-day" style={styles.navButtonIcon}></i> The Five Days Different
  </button>
</nav>


          <div style={styles.featureBlocks}>
            <div style={styles.featureBlock}>
              <img src="/assets/seated.png" alt="Yoga practice in nature" style={styles.featureImg} />
  
  
   
   
 
 
 
              <div style={styles.featureContent}>
                <h2 style={styles.featureH2}>Discover Hash House Yoga</h2>
 
 
                <p style={styles.featureP}>
                  Hash House Yoga is not an escape from reality; it is the essential operating system for engaging with it. 
                  As a minimum required practice, we offer a nomothetic, science-backed approach to human performance designed to help you reclaim your "now." 
                  By applying minimum effective doses of breath, movement, and analytical problem-solving, HHY moves you from a state of passive reaction to active, intentional control. 
                  Discover how to unify your mind, body, and breath to find, maintain, and deepen your experience of peace and comfort.
                </p>
              </div>
            </div>
            <div style={styles.featureBlock}>
              <img src="/assets/forwardfold.png" alt="Morning yoga pose" style={styles.featureImg} />
              <div style={styles.featureContent}>
                <h2 style={styles.featureH2}>Transform Your Practice</h2>
                <p style={styles.featureP}>
                  Move beyond passive consumption and start actively architecting your life. 
                  Our practice is built on utility and efficiency, transforming the automatic functions you do every day—breathing, moving, and doing—into powerful tools for centering.
                </p>
              </div>
            </div>
          </div>
        </main>

        <section style={styles.seoSections}>
													   


  
	
		 
 

          <div style={{...styles.seoSection, gridColumn: 'span 1'}}>
  
	   
 

   
            <h3 style={styles.seoSectionH3}>Additional Information</h3>
			
 
  
 

  
 
   
 

  
  
 
 
   
  
											
            <ul style={styles.seoLinkList}>
              <li style={styles.seoLinkListItem}>
                <a href="pages/teacher-training.html" style={styles.seoLink}>
                  <i className="fas fa-graduation-cap" style={styles.seoLinkIcon}></i> Teacher Training
                </a>
              </li>
              <li style={styles.seoLinkListItem}>
                <a href="pages/sample-chapters.html" style={styles.seoLink}>
                  <i className="fas fa-book-open" style={styles.seoLinkIcon}></i> Sample Chapters
                </a>
              </li>
              <li style={styles.seoLinkListItem}>
                <a href="pages/science.html" style={styles.seoLink}>
                  <i className="fas fa-microscope" style={styles.seoLinkIcon}></i> The Science
                </a>
              </li>
            </ul>

            <p style={{marginTop: '20px'}}>
              Learn more about the philosophy behind HHY and the extensive resources available to our community.
            </p>
          </div>

          <div style={{...styles.seoSection, gridColumn: 'span 1'}}>
            <h3 style={styles.seoSectionH3}>Programs & Philosophy</h3>
            <p>Our philosophy is grounded in the "N of 1" application of science, the belief that you are the ultimate authority on your own experience. 
            We provide the framework: a universal, data-driven system of "minimum daily requirements" for mental and emotional hygiene. 
            From the atomic unit of the Five Breath Experience (5BE) to the transformative 120-hour Five Days Different (5DD) course, 
            our programs apply a scientific problem-solving arc to your real-world challenges. 
            This is not just yoga; it is a utility for taking intentional control of your anxiety, stress, and daily life. 
            Designed for PTSD, Perimenopause, Medicine titration, Performance Enhancement, & a variety of other targets.     
            </p>
          </div>

  
 
   
 

          <div style={{...styles.seoSection, gridColumn: 'span 1'}}>
            <h3 style={styles.seoSectionH3}>Community & Connection</h3>
            <p>True transformation is most sustainable when shared. Our unique "Triad" model is built on the belief that accountability drives success, which is why we structure our programs to ensure you never have to practice alone. Through our "Buy One, Get One" access for new users and graduate-led mentorship groups, we foster a network where users become guides. By connecting with partners on the same journey of intentional control, you build a resilient support system that turns individual effort into collective mastery, helping you and your community maintain a shared state of peace.</p></div>
        </section>

        <footer style={styles.footer}>
          <div style={{marginBottom: '8px'}}>
            <a href="/privacy" style={{color: '#ccc', marginRight: '20px', textDecoration: 'none'}}>Privacy Policy</a>
            <a href="/terms" style={{color: '#ccc', textDecoration: 'none'}}>Terms of Service</a>
          </div>
          &copy; 2026 Hash House Yoga. All rights reserved.
        </footer>
      </div>
    </div>
  );
}

export default LandingPage;